var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"progressive-image",class:[{ 'is-loaded': _vm.isLoaded }, _vm.customClass],attrs:{"src":_vm.src,"alt":_vm.alt},on:{"load":_vm.handleLoad}})}
var staticRenderFns = []

export { render, staticRenderFns }